import { Box, CircularProgress, Modal } from "@mui/material";
import React from "react";
import { KeyDriveBodyMax } from "../Fonts/Body/KeyDriveBodyMax";
import { KeyDriveh2Header } from "../Fonts/Headers/KeyDriveh2Header";

interface IKeydriveSimpleModal {
    modalOpen: boolean;
    modalClose: () => void;
    loading?: boolean;
    icon?: React.ReactNode;
    title: string;
    bodyContent: string;
    children?: React.ReactNode;
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "600px",
    height: "248px",
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: "30px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
};

export const KeydriveSimpleModal: React.FC<IKeydriveSimpleModal> = ({
    modalClose,
    modalOpen,
    loading,
    icon,
    title,
    bodyContent,
    children
}) => {
    return (
        <Modal
            open={modalOpen}
            onClose={modalClose}
            aria-labelledby="Keydrive-Information-modal"
            aria-describedby="keydrive-Information-modal-description"
        >
            { children != undefined ? (
                <>
                    { children }
                </>
            ) : (
                <Box sx={style}>
                    { loading ? (
                        <CircularProgress />
                    ) : (
                        <>
                            { icon }
                        </>
                    ) }
                    <Box mt="20px">
                        <KeyDriveh2Header 
                            color="#2D2D2D"
                            needBold={false}
                            needEllipses={false}
                            text={title}
                        />
                    </Box>
                    <Box mt="10px">
                        <KeyDriveBodyMax 
                            color="#575757"
                            needBold={false}
                            needEllipses={false}
                            text={bodyContent}
                        />
                    </Box>
                </Box>
            ) }
        </Modal>
    )
}